module.exports = __webpack_public_path__ + "static/media/Sols_icon.a5268114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tmp/Sols_icon.png
// module id = 221
// module chunks = 0